import React, { useEffect, useState } from 'react';
import { usePostHog } from 'posthog-js/react';

// Visible on-screen PostHog diagnostics. Only renders in non-prod environments.
// Polls every second so the display refreshes after reset() or identify() calls.
const PostHogDebug: React.FC = () => {
  const posthog = usePostHog();
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  if (process.env.REACT_APP_DEPLOY_ENV === 'prod') {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-underscore-dangle
  const initialized = Boolean(posthog && (posthog as any).__loaded);
  const distinctId = posthog?.get_distinct_id() ?? '—';
  const sessionRecording = Boolean(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    posthog && (posthog as any).sessionRecordingStarted?.(),
  );

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(0,0,0,0.85)',
        color: initialized ? '#4ade80' : '#f87171',
        fontSize: 11,
        lineHeight: '18px',
        padding: '4px 8px',
        zIndex: 9999,
        fontFamily: 'monospace',
        wordBreak: 'break-all',
      }}
    >
      <span style={{ marginRight: 12 }}>
        PostHog:
        {' '}
        {initialized ? '✓ initialized' : '✗ NOT initialized'}
      </span>
      <span style={{ marginRight: 12 }}>
        recording:
        {' '}
        {sessionRecording ? '✓' : '✗'}
      </span>
      <span>
        distinct_id:
        {distinctId}
      </span>
    </div>
  );
};

export default PostHogDebug;
